import { Reducer } from "@reduxjs/toolkit"
import { EstadoRequisicao } from "store/types"
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils"
import { UnidadesUFCAction } from "./UnidadesUFC.action"
import { UnidadesUFCActionTypes, UnidadesUFCState } from "./UnidadesUFC.types"


const estadoInicial: UnidadesUFCState = {
  estado: EstadoRequisicao.OCIOSO,
  currentRequestId: undefined,

  erros: undefined,

  estruturaOrganizacional: undefined,
  cache: {},
}


export const unidadesUFCReducer: Reducer<UnidadesUFCState, UnidadesUFCActionTypes> = (state = estadoInicial, action): UnidadesUFCState => {
  if (UnidadesUFCAction.carregar.pending.match(action)) {
    if (state.estado !== EstadoRequisicao.OCIOSO) {
      return state;
    }

    return {
      ...state,

      estado: EstadoRequisicao.CARREGANDO,
      currentRequestId: action.meta.requestId,
      erros: undefined,
    }

  } else if (UnidadesUFCAction.carregar.fulfilled.match(action)) {
    if (action.payload === undefined
     || state.estado !== EstadoRequisicao.CARREGANDO
     || state.currentRequestId !== action.meta.requestId) {
      return state;
    }



    return {
      ...state,

      estado: EstadoRequisicao.BEM_SUCEDIDO,
      currentRequestId: undefined,
      erros: undefined,

      estruturaOrganizacional: action.payload.unidades,
      cache: action.payload.cache
    }

  } else if (UnidadesUFCAction.carregar.rejected.match(action)) {
    if (state.estado !== EstadoRequisicao.CARREGANDO
     || state.currentRequestId !== action.meta.requestId) {
      return state;
    }

    return {
      ...state,

      estado: EstadoRequisicao.FALHOU,
      currentRequestId: undefined,
      erros: action.payload as ResponseError,
    }
  }


  return state;
}
